export default {
  pt: {
    app: {
      readMore: 'Ler mais',
      back: 'Voltar',
      forYourBusiness: 'para o seu negócio',
      menu: {
        about: 'Sobre nós',
        solutions: 'Soluções',
        cases: 'Casos',
        /* events: 'Eventos', */
        CookiePolicy:'Politica de Cookie',
        PrivacyPolicy:'Politica de Privacidade',
        contacts: 'Contactos',
        people: 'Pessoas',
        policy: 'Políticas',
        responsibility: 'Responsabilidade Social',
        heroes: 'Os Nossos Heróis',
        jobs: 'Junte-se a nós'
      },
      fullscreenText: 'Para melhor experiência altere para fullscreen',
      cancelButton: 'Cancelar',
      activateFullScreenButton: 'Activar fullscreen',
      cookieBanner: {
        ariaLabel: 'Aviso de cookies',
        text: 'Este site utiliza cookies para melhorar a sua experiência e tornar o site mais eficaz, mediante o seu consentimento. Ao continuar a navegar no site, você concorda com a nossa política de cookies.',
        readCookiePolicy: 'Leia aqui a política de cookies',
        and: 'e',
        readPrivacyPolicy: 'a política de privacidade',
        acceptAriaLabel: 'Aceitar cookies',
        accept: 'Aceitar Cookies'
      }
    }
  },

  en: {
    app: {
      readMore: 'Read More',
      back: 'Back',
      forYourBusiness: 'for your business',
      menu: {
        about: 'About us',
        solutions: 'Solutions',
        cases: 'Cases',
        contacts: 'Contacts',
       /*  events: 'Eventos', */
        CookiePolicy: 'Cookie Policy',
        PrivacyPolicy: 'Privacy Policy',
        people: 'People',
        policy: 'Policy',
        responsibility: 'Social Responsibility',
        heroes: 'Our Heroes',
        jobs: 'Join us'
      },
      fullscreenText: 'For best experience change to fullscreen',
      cancelButton: 'Cancel',
      activateFullScreenButton: 'Activate Fullscreen',
      cookieBanner: {
        ariaLabel: 'Cookie notice',
        text: 'This site uses cookies to improve your experience and make the site more effective, subject to your consent. By continuing to browse the site, you agree to our cookie policy.',
        readCookiePolicy: 'Read our cookie policy here',
        and: 'and',
        readPrivacyPolicy: 'our privacy policy',
        acceptAriaLabel: 'Accept cookies',
        accept: 'Accept Cookies'
      }
    }
  }
}
